import { Navigate } from 'react-router';
import { useAuthStore } from '../store/authStore';

function RouteLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_#ffffff_0%,_#f4f5f7_58%,_#e7eaef_100%)]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#d7dce2] border-t-[#2e86b5]" />
    </div>
  );
}

export function withPublicRoute(Component) {
  function PublicRoute(props) {
    const hasHydrated = useAuthStore((state) => state.hasHydrated);
    const isAuthenticated = useAuthStore((state) => Boolean(state.session));

    if (!hasHydrated) {
      return <RouteLoader />;
    }

    if (isAuthenticated) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Component {...props} />;
  }

  PublicRoute.displayName = `withPublicRoute(${
    Component.displayName || Component.name || 'Component'
  })`;

  return PublicRoute;
}
